import React from 'react';

const IsMobile = React.createContext(false);

export default IsMobile;
